module.exports = __webpack_public_path__ + "img/bottle-pink@2x.e773d1cd.png";